import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaleService } from '../../services';
import { MarsPrivacyPolicyService } from '../../services/mars-privacy-policy.service';
import { AuthService } from '../auth.service';
import { SocialLogin } from '../auth.types';
import { TranslateModule } from '@ngx-translate/core';
import { TrackingDirective } from '../../services/tracking/tracking.directive';
import { AsyncPipe } from '@angular/common';
import { EnvironmentService } from '@app/core/environment.service';
import { StorageService } from '@app/core/services/storage/storage.service';
import { LocationService } from '@app/core/services/location.service';
import { environment } from '../../../../environments/environment';
import { RedirectsService } from '@app/core/services/redirect/redirects.service';
import { DefaultSocials } from '@app/core/models/default-socials';
import { InitiatorService } from '@app/core/services/initiator.service';

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TrackingDirective, AsyncPipe, TranslateModule],
})
export class AuthLoginComponent implements OnInit {
  private localeService = inject(LocaleService);
  private environnementService = inject(EnvironmentService);
  private authService = inject(AuthService);
  private marsPrivacyPolicyService = inject(MarsPrivacyPolicyService);
  private activatedRoute = inject(ActivatedRoute);
  private storageService = inject(StorageService);
  private locationService = inject(LocationService);
  private redirectsService = inject(RedirectsService);
  private readonly InitiatorService = inject(InitiatorService);
  private router = inject(Router);

  openTermsHref$ = this.marsPrivacyPolicyService.openTermsHref$;

  isDefaultSocialAvailable!: boolean;
  isKakaoAvailable!: boolean;

  ngOnInit(): void {
    this.isDefaultSocialAvailable =
      this.environnementService.isDefaultSocialsAvailable(
        this.localeService.getCountry(),
        this.localeService.getLanguageCode(),
      );
    this.isKakaoAvailable =
      this.environnementService.isSocialAvailableForClientID('kakao');
  }

  loginWithSocial(social: SocialLogin): void {
    this.redirectsService
      .getSecuredCallbackUri(this.activatedRoute.snapshot.queryParams)
      .subscribe((callbackUri) => {
        if (callbackUri) {
          this.storageService.setLocal<string>(
            'redirect_uri_after_social_login',
            callbackUri,
          );
          const consentsRedirectUri = `${this.locationService.getFullUrl()}consents?client=${this.InitiatorService.clientId}`;

          if (environment.okta.socialIdp[social]) {
            this.authService.loginRedirect(
              consentsRedirectUri,
              environment.okta.socialIdp[social],
            );
          }
        } else {
          this.router.navigate(['/error'], { queryParamsHandling: 'preserve' });
        }
      });
  }

  isDefaultSocialAvailableForClientID(socialNetwork: DefaultSocials): boolean {
    return this.environnementService.isDefaultSocialAvailableForClientID(
      socialNetwork,
    );
  }
}
